import React from "react";
import "./Popular_product_cards.css";

function Popular_product_cards({card_heading, imgSrc}) {
  return (
    <>
      <section className="Popular_product_cards">
        <div className="Popular_product_cards_heading">
          <h4>{card_heading}</h4>
        </div>
        <div className="product_img_holder">
          <img
            src={process.env.PUBLIC_URL + imgSrc}
            className="product_img"
            alt="product_img"
          />
        </div>
      </section>
    </>
  );
}

export default Popular_product_cards;
